/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { ISurveySections } from 'app/shared/model/survey-sections.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPatientSurvey } from 'app/shared/model/patient-survey.model';
import { CompletedByType } from 'app/shared/model/enumerations/completed-by-type.model';

export interface IPatientSurveySections {
  id?: string;
  completedOn?: dayjs.Dayjs | null;
  completedByType?: keyof typeof CompletedByType | null;
  completedById?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surveySection?: ISurveySections;
  patient?: IGlucoUser;
  patientSurvey?: IPatientSurvey | null;
}

export const defaultValue: Readonly<IPatientSurveySections> = {
  active: false,
};
